import { AnyDocument, WorkflowState } from '../../../types';
import { Entity } from '../../../types/utility';
import { ConstructPatch } from '../../types/ConstructPatch';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const patchDocument = async (
  constructPatch: ConstructPatch,
  documentId: string,
  documentParams: DocumentParams,
  data: Entity,
): Promise<NonPaginatedResponse<AnyDocument, WorkflowState> | undefined> =>
  constructPatch(
    `${DOCUMENTS_BASE_PATH}/${documentId}`,
    { data, headers: buildHeadersFromDocumentParams(documentParams) },
    { preventDefaultErrorToast: true },
  );
